<script setup lang="ts">
import VkAuthButton from '~/components/auth/VkAuthButton.vue';
import YandexAuthButton from '~/components/auth/YandexAuthButton.vue';
import VButton from '~/components/VButton.vue';
import VDivider from '~/components/VDivider.vue';
import VInput from '~/components/VInput.vue';
import { useAuthStore } from '~/stores/AuthStore';
import AuthHeader from './AuthHeader.vue';
import PasswordInput from './PasswordInput.vue';

const authStore = useAuthStore();
const loading = ref(false);

async function handleLogin() {
  loading.value = true;
  await authStore.login();
  loading.value = false;
  if (authStore.token) authStore.authError = '';
  if (!authStore.authError) authStore.handleIsOpened(false);
}

function clearForm() {
  authStore.authError = '';
  authStore.email = '';
  authStore.password = '';
}
</script>

<template>
  <form
    class="auth"
    @keydown.enter.prevent="handleLogin"
    @submit.prevent="handleLogin"
  >
    <AuthHeader title="Вход в аккаунт" />

    <div class="auth__buttons-id">
      <YandexAuthButton />
      <VkAuthButton />
    </div>

    <v-divider
      text
      is-gray
    />

    <div class="auth__actions">
      <v-input
        v-model="authStore.email"
        required
        type="email"
        autofocus
        placeholder="Почта"
        aria-label="Email"
        autocomplete="email"
      />

      <PasswordInput
        v-model="authStore.password"
        required
        autocomplete="current-password"
        aria-label="Пароль"
      />

      <div
        v-if="authStore.authError"
        class="error mb-3"
        role="alert"
      >
        {{ authStore.authError }}
      </div>

      <v-button
        type="submit"
        medium
        :disabled="loading || !authStore.password || !authStore.email"
        :aria-busy="loading"
      >
        Войти
      </v-button>
    </div>

    <div class="auth__footer">
      <v-button
        schema="text"
        type="button"
        @click="
          authStore.handleIsOpened('register');
          clearForm();
        "
      >
        Зарегистрироваться
      </v-button>
    </div>
  </form>
</template>

<style scoped lang="scss">
.auth {
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;

  .auth__buttons-id {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .auth__actions {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;

    .new-button {
      width: 100%;
    }
  }

  .auth__footer {
    font-size: 14px;
    line-height: 20px;
    color: #9691f0;
  }

  .error {
    color: $text-status-destructive;
  }
}
</style>
